import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export function Input({ className, type, ...props }: ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'border-input placeholder:text-muted-foreground/70 flex min-h-11 w-full rounded-lg border bg-white/[0.03] px-3.5 py-2 text-base transition-[border-color,box-shadow] outline-none',
        'focus-visible:border-ring focus-visible:ring-ring/25 focus-visible:ring-[3px]',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'aria-invalid:border-destructive aria-invalid:ring-destructive/20 aria-invalid:ring-[3px]',
        className,
      )}
      {...props}
    />
  );
}
